(() => {
  const y2kPattern = /\bY2K\b/gi;
  const ignoredSelector = '.y2k-label, .y2k-text, script, style, noscript, textarea, select, option, code, pre, [contenteditable="true"]';

  function canNormalize(node) {
    const parent = node.parentElement;

    return (
      parent &&
      !parent.closest(ignoredSelector) &&
      /\bY2K\b/i.test(node.nodeValue || '')
    );
  }

  function normalizeTextNode(node) {
    const value = node.nodeValue || '';
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;

    value.replace(y2kPattern, (match, offset) => {
      fragment.append(value.slice(lastIndex, offset));

      const label = document.createElement('span');
      label.className = 'y2k-label';
      label.textContent = match;
      fragment.append(label);

      lastIndex = offset + match.length;
      return match;
    });

    fragment.append(value.slice(lastIndex));
    node.replaceWith(fragment);
  }

  function normalize(root) {
    if (!root || !/\bY2K\b/i.test(root.textContent || '')) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node = walker.nextNode();

    while (node) {
      if (canNormalize(node)) nodes.push(node);
      node = walker.nextNode();
    }

    nodes.forEach(normalizeTextNode);
  }

  function observeDynamicContent() {
    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            if (canNormalize(node)) normalizeTextNode(node);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            normalize(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initialize() {
    normalize(document.body);
    observeDynamicContent();
    document.addEventListener('shopify:section:load', (event) => normalize(event.target));
  }

  if (document.body) {
    initialize();
  } else {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  }
})();
